import { handleActions } from 'redux-actions';
import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';

import actions from 'state/auth/actionCreators';
import initialState from 'state/auth/initial.state';

const authPersistConfig = {
  key: 'auth',
  storage,
  blacklist: ['error', 'loading'],
};

const reducer = handleActions(
  {
    [actions.setError]: (state, { payload: { error } }) => ({
      ...state,
      error,
    }),
    [actions.setUser]: (state, { payload: { user } }) => ({
      ...state,
      user,
    }),
    [actions.setShipper]: (state, { payload: { shipper } }) => ({
      ...state,
      shipper,
    }),
    [actions.setLoading]: (state, { payload: { loading } }) => ({
      ...state,
      loading,
    }),
    [actions.setCredentials]: (state, { payload: { credentials } }) => ({
      ...state,
      credentials,
    }),
  },
  initialState
);

export default persistReducer(authPersistConfig, reducer);
